// components/NotificationBell.tsx
import { useState, useEffect } from "react";
import NotificationPanel from "@shared/components/Notification/NotificationPanel";
import { NotificationsContextType } from "@utils/useNotifications";

interface NotificationBellProps {
  notificationsContext: NotificationsContextType;
}

const NotificationBell: React.FC<NotificationBellProps> = ({
  notificationsContext,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    notifications,
    setNotifications,
    unreadCount,
    resetNotifications,
    markAsRead,
    markAllAsRead,
    loadMoreNotifications,
    hasMore,
  } = notificationsContext;

  useEffect(() => {
    if (isOpen) resetNotifications();
  }, [isOpen]);

  return (
    <div className="relative">
      <button
        className="p-2 rounded-full hover:bg-gray-200 relative"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="2xl:w-6 2xl:h-6 w-5 h-5 text-gray-600"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14V9a6 6 0 10-12 0v5c0 .386-.114.761-.328 1.086L4 17h5m6 0a3 3 0 01-6 0"
          />
        </svg>
        {unreadCount > 0 && (
          <span className="absolute top-1 right-1 bg-red-500 text-white text-[0.6rem] 2xl:text-xs rounded-full px-1">
            {unreadCount}
          </span>
        )}
      </button>

      <NotificationPanel
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        notifications={notifications}
        setNotifications={setNotifications}
        markAsRead={markAsRead}
        markAllAsRead={markAllAsRead}
        hasMore={hasMore}
        loadMoreNotifications={loadMoreNotifications}
      />
    </div>
  );
};

export default NotificationBell;
